<template>
  <div class="w-source">
    <router-view/>
<!--    <wheelLandIntercept></wheelLandIntercept>-->
  </div>
</template>

<script>
  // import wheelLandIntercept from './components/wheelLandIntercept'

  export default {
    name: 'App',
    // components: {wheelLandIntercept},
    mounted() {
      this.init()
        // console.log(this.$route)
      // console.log(this.$route.params)
      // this.$router.push({path: `/info/${25}`,})
      // this.$router.push({ name: 'taskInfo',params:{projectId:59286,taskId:34}})
    },
    methods:{
      async init(){
        let ids = location.hash.split('/')
        let companyId = null
        if(ids[1] == 'serveHall'){
          companyId = ids[2]
        }else if(ids[1] == 'shareWorkTable'){
          companyId = ids[3].split('_')[3] / 124
        }
        if(process.env.NODE_ENV === "production"){
          let res = await this.$store.dispatch('share/grayCompanyIdList', {})
          if(!res.code){
            let companyIds = res.data || []
            if(companyIds.includes(Number(companyId))){
              window.location.href = location.origin + '/h5/index.html' + location.hash;
            }
          }
        }
      }
    }
  }

//ios禁止缩放
//   window.onload = function() {
//     document.addEventListener('touchstart', function(event) {
//       if (event.touches.length > 1) {
//         event.preventDefault()
//       }
//     })
//     document.addEventListener('gesturestart', function(event) {
//       event.preventDefault()
//     })
//   }
</script>
<style lang="scss">
.el-scrollbar .el-scrollbar__bar{
  opacity: 1 !important;
}
</style>


// WEBPACK FOOTER //
// src/App.vue